var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-select"},[(_vm.optionsReady)?_c('v-searchable-select',_vm._b({attrs:{"options":_vm.options,"label":"name","option-id":"value","simple-select":""},on:{"input":function($event){return _vm.onInput($event)}}},'v-searchable-select',_vm.$attrs,false)):_vm._e(),_c('div',{staticClass:"v-select__slot"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }